import { FormInputInterface } from "@/components/Form/FormInput/FormInput.interface";

import React from "react";

import { twMerge } from "tailwind-merge";

import ErrorTooltip from "../ErrorTooltip";

const getValidationRule = (value?: string | number, message?: string) => {
  if (value) {
    if (message) {
      return { value, message };
    }
    return value;
  }
  return undefined;
};

export const FormInput: React.FC<FormInputInterface> = ({
  name,
  id,
  label,
  register,
  required,
  error,
  locked,
  onChange,
  minLength,
  regexPattern,
  min,
  max,
  minMaxError,
  patternError,
  disabled,
  validationFunction,
  showErrorInTooltip,
}) => {
  return (
    <div className="flex flex-col">
      <label
        htmlFor={id}
        className="font-dm-sans text-sm font-medium text-black empty:hidden"
      >
        {label}
        {label && required && " *"}
      </label>
      <div className="relative flex flex-col">
        {!locked ? (
          <input
            disabled={disabled}
            type="text"
            id={id}
            className={twMerge(
              "font-dm-sans placeholder:text-grey4 disabled:border-grey3 disabled:text-grey6 box-border h-10 rounded-none border border-black px-3 text-sm",
              "focus:outline-2 focus:-outline-offset-2 focus:outline-solid",
              error &&
                "border-carrot-red bg-light-peach focus:outline-carrot-red border",
            )}
            autoComplete="off"
            data-1p-ignore
            {...register(name, {
              required,
              onChange,
              pattern: regexPattern,
              validate: validationFunction,
              min: getValidationRule(min, minMaxError),
              max: getValidationRule(max, minMaxError),
              minLength,
            })}
          />
        ) : (
          <div className="text-grey4 flex items-center py-1">-</div>
        )}
        <ErrorTooltip
          error={error}
          label={label}
          minLength={minLength}
          patternError={patternError}
          showErrorInTooltip={showErrorInTooltip}
        />
      </div>
    </div>
  );
};

export default FormInput;
